module.exports = __webpack_public_path__ + "img/newsImg11-33.a871ed5b.png";